'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPersistedThreadIdentifier = undefined;

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

/*
  * @param {number | 'STUBBED_CHANNEL'} threadId or stubbed channel identifier
  * @returns {Boolean} whether the threadId is real or
  *                    for a stubbed thread
*/
var isPersistedThreadIdentifier = exports.isPersistedThreadIdentifier = function isPersistedThreadIdentifier(identifier) {
  return identifier !== _stubbedChannel.STUBBED_CHANNEL;
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/operators/isPersistedThreadIdentifier.js
// module id = 658
// module chunks = 2 3